import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { brandingService } from "services";
import { uiActions } from "store";
import { BrandingSettingsTypes, ErrorResponse } from "types";

const useSetSupportingMessageAgentMutation = (agentId: string) => {
	const dispatch = useDispatch();

	return useMutation(
		({ settings }: { settings: BrandingSettingsTypes }) => {
			return brandingService.setSupportingMessageAgent({
				agentId,
				settings: {
					supporting_message: settings?.supportingMessage,
				},
			});
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useSetSupportingMessageAgentMutation;
